/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
};

/** Autogenerated return type of AdmitAttendee. */
export type AdmitAttendeePayload = {
  __typename?: 'AdmitAttendeePayload';
  /** The updated registration */
  registration: Registration;
};

/** Autogenerated return type of CertifyRegistration. */
export type CertifyRegistrationPayload = {
  __typename?: 'CertifyRegistrationPayload';
  /** The certified registration */
  registration: Registration;
};

/** Autogenerated return type of DecertifyRegistration. */
export type DecertifyRegistrationPayload = {
  __typename?: 'DecertifyRegistrationPayload';
  /** The decertified registration */
  registration: Registration;
};

/** Autogenerated return type of MarkAttendeeAttended. */
export type MarkAttendeeAttendedPayload = {
  __typename?: 'MarkAttendeeAttendedPayload';
  /** The updated registration */
  registration: Registration;
};

/** Autogenerated return type of MarkAttendeeNoShow. */
export type MarkAttendeeNoShowPayload = {
  __typename?: 'MarkAttendeeNoShowPayload';
  /** The updated registration */
  registration: Registration;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Admit an attendee to a course (approves pending registrations) */
  admitAttendee?: Maybe<AdmitAttendeePayload>;
  /** Certify a registration */
  certifyRegistration?: Maybe<CertifyRegistrationPayload>;
  /** Decertify a registration */
  decertifyRegistration?: Maybe<DecertifyRegistrationPayload>;
  /** Mark attendee as attended */
  markAttendeeAttended?: Maybe<MarkAttendeeAttendedPayload>;
  /** Mark attendee as no-show */
  markAttendeeNoShow?: Maybe<MarkAttendeeNoShowPayload>;
  /** Register an attendee for a course */
  registerAttendee?: Maybe<RegisterAttendeePayload>;
  /** Update registration fields (e.g., remarks) */
  updateRegistration?: Maybe<UpdateRegistrationPayload>;
  /** Move attendee to waitlist */
  waitlistAttendee?: Maybe<WaitlistAttendeePayload>;
};


export type MutationAdmitAttendeeArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationCertifyRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationDecertifyRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationMarkAttendeeAttendedArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationMarkAttendeeNoShowArgs = {
  registrationId: Scalars['ID']['input'];
};


export type MutationRegisterAttendeeArgs = {
  attendeeId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRegistrationArgs = {
  registrationId: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWaitlistAttendeeArgs = {
  registrationId: Scalars['ID']['input'];
};

export type PaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  /** Are there more pages after the current page? */
  hasNextPage: Scalars['Boolean']['output'];
  /** Are there more pages before the current page? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items returned */
  itemCount: Scalars['Int']['output'];
  /** Number of items per page */
  limit: Scalars['Int']['output'];
  /** Next page number if it exists */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of items on next page */
  nextPageItemCount: Scalars['Int']['output'];
  /** Current page number */
  page: Scalars['Int']['output'];
  /** Previous page number if it exists */
  previousPage?: Maybe<Scalars['Int']['output']>;
  /** Number of remaining items available */
  remainingItemCount: Scalars['Int']['output'];
  /** Total number of items available */
  totalItemCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPageCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Fetch all registrations for a specific course */
  iltCourseRegistrations: RegistrationPagination;
  iltRegistration: Registration;
  /** Fetch all registrations for a specific user */
  iltUserRegistrations: RegistrationPagination;
};


export type QueryIltCourseRegistrationsArgs = {
  courseId: Scalars['ID']['input'];
  filter?: InputMaybe<RegistrationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIltRegistrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIltUserRegistrationsArgs = {
  filter?: InputMaybe<RegistrationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegisterAttendee. */
export type RegisterAttendeePayload = {
  __typename?: 'RegisterAttendeePayload';
  /** The created registration */
  registration: Registration;
};

export type Registration = {
  __typename?: 'Registration';
  attendee: User;
  attendeeId: Scalars['ID']['output'];
  certified: Scalars['Boolean']['output'];
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  status: RegistrationStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RegistrationFilterInput = {
  /** Search query for filtering registrations */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by registration status */
  status?: InputMaybe<Array<RegistrationStatus>>;
};

export type RegistrationPagination = {
  __typename?: 'RegistrationPagination';
  nodes: Array<Registration>;
  pageInfo: PaginationPageInfo;
};

export enum RegistrationStatus {
  /** Attendee has attended the course */
  Attended = 'attended',
  /** Attendee did not show up for the course */
  NoShow = 'no_show',
  /** Registration is pending (on waitlist) */
  Pending = 'pending',
  /** Registration has a confirmed seat */
  Registered = 'registered'
}

/** Autogenerated return type of UpdateRegistration. */
export type UpdateRegistrationPayload = {
  __typename?: 'UpdateRegistrationPayload';
  /** The updated registration */
  registration: Registration;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iltRegistrations: Array<Registration>;
  lastName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};


export type UserIltRegistrationsArgs = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<RegistrationStatus>;
};

/** Autogenerated return type of WaitlistAttendee. */
export type WaitlistAttendeePayload = {
  __typename?: 'WaitlistAttendeePayload';
  /** The updated registration */
  registration: Registration;
};

export type EventRegistrationsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  courseId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<RegistrationFilterInput>;
}>;


export type EventRegistrationsQuery = { __typename?: 'Query', iltCourseRegistrations: { __typename?: 'RegistrationPagination', nodes: Array<{ __typename?: 'Registration', id: string, status: RegistrationStatus, remarks?: string | null, certified: boolean, attendee: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, displayName?: string | null, department?: string | null, position?: string | null } }>, pageInfo: { __typename?: 'PaginationPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, itemCount: number, nextPage?: number | null } } };

export type AdmitAttendeeMutationVariables = Exact<{
  registrationId: Scalars['ID']['input'];
}>;


export type AdmitAttendeeMutation = { __typename?: 'Mutation', admitAttendee?: { __typename?: 'AdmitAttendeePayload', registration: { __typename?: 'Registration', status: RegistrationStatus, attendee: { __typename?: 'User', displayName?: string | null } } } | null };

export type MarkAttendeeNoShowMutationVariables = Exact<{
  registrationId: Scalars['ID']['input'];
}>;


export type MarkAttendeeNoShowMutation = { __typename?: 'Mutation', markAttendeeNoShow?: { __typename?: 'MarkAttendeeNoShowPayload', registration: { __typename?: 'Registration', status: RegistrationStatus, attendee: { __typename?: 'User', displayName?: string | null } } } | null };

export type MarkAttendeeAttendedMutationVariables = Exact<{
  registrationId: Scalars['ID']['input'];
}>;


export type MarkAttendeeAttendedMutation = { __typename?: 'Mutation', markAttendeeAttended?: { __typename?: 'MarkAttendeeAttendedPayload', registration: { __typename?: 'Registration', status: RegistrationStatus, attendee: { __typename?: 'User', displayName?: string | null } } } | null };

export type WaitlistAttendeeMutationVariables = Exact<{
  registrationId: Scalars['ID']['input'];
}>;


export type WaitlistAttendeeMutation = { __typename?: 'Mutation', waitlistAttendee?: { __typename?: 'WaitlistAttendeePayload', registration: { __typename?: 'Registration', status: RegistrationStatus, attendee: { __typename?: 'User', displayName?: string | null } } } | null };

export type UpdateRegistrationMutationVariables = Exact<{
  registrationId: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRegistrationMutation = { __typename?: 'Mutation', updateRegistration?: { __typename?: 'UpdateRegistrationPayload', registration: { __typename?: 'Registration', id: string, remarks?: string | null } } | null };


export const EventRegistrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventRegistrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iltCourseRegistrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"certified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"itemCount"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}}]}}]}}]}}]} as unknown as DocumentNode<EventRegistrationsQuery, EventRegistrationsQueryVariables>;
export const AdmitAttendeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdmitAttendee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"admitAttendee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<AdmitAttendeeMutation, AdmitAttendeeMutationVariables>;
export const MarkAttendeeNoShowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAttendeeNoShow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAttendeeNoShow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<MarkAttendeeNoShowMutation, MarkAttendeeNoShowMutationVariables>;
export const MarkAttendeeAttendedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAttendeeAttended"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAttendeeAttended"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<MarkAttendeeAttendedMutation, MarkAttendeeAttendedMutationVariables>;
export const WaitlistAttendeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"WaitlistAttendee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waitlistAttendee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attendee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<WaitlistAttendeeMutation, WaitlistAttendeeMutationVariables>;
export const UpdateRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remarks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRegistration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"registrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"remarks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remarks"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRegistrationMutation, UpdateRegistrationMutationVariables>;